import { Action } from 'common/actions/appAction';

export const APP_INIT = 'APP_INIT';
export type AppInitAction = Action<typeof APP_INIT>;
export const appInit = (): AppInitAction => ({
    type: APP_INIT,
});
